export enum Privilege {
  Admin = 300,
  Agent = 200,
  User = 100,
  Anonymous = 0,
}
